import {Routes} from '@angular/router';
import {PrivateComponent} from './private.component';
import {HomeComponent} from './home/home.component';
import {AuthGuardService} from '../services/auth-guard.service';
import {ProductsComponent} from './products/products.component';
import {ProductComponent} from './products/product/product.component';
import {OrdersComponent} from './orders/orders.component';
import {OrderComponent} from './orders/order/order.component';
import {ProductUpdateComponent} from './products/product-update/product-update.component';
import {ClientsComponent} from './clients/clients.component';
import {BalanceComponent} from './balance/balance.component';
import {ChoosePackagesComponent} from './choose-packages/choose-packages.component';
import {ConfirmChoosingPackageComponent} from './confirm-choosing-package/confirm-choosing-package.component';
import {ProcessPaymentComponent} from './process-payment/process-payment.component';
import {RenewSubscriptionComponent} from './renew-subscription/renew-subscription.component';
import {SubAccountsComponent} from './sub-accounts/sub-accounts.component';
import {ProcessSubAccountPaymentComponent} from './sub-accounts/process-sub-account-payment/process-sub-account-payment.component';
import {NewSubAccountsRequestListComponent} from './sub-accounts/new-sub-accounts-request-list/new-sub-accounts-request-list.component';
import {SubAccountsAssignmentFormComponent} from './sub-accounts/sub-accounts-assignment-form/sub-accounts-assignment-form.component';
import {ThemeSettingsComponent} from './theme-settings/theme-settings.component';
import {SettingsListComponent} from './settings-list/settings-list.component';
import {SettingsUpdateComponent} from './settings/settings-update/settings-update.component';
import {BankUpdateComponent} from './settings/bank-update/bank-update.component';
import {SubscriptionUpdateComponent} from './settings/subscription-update/subscription-update.component';
import {ApiKeysComponent} from './settings/api-keys/api-keys.component';
import {RequestUpdateAccountComponent} from './settings/request-update-account/request-update-account.component';
import {CategoriesComponent} from './categories/categories.component';
import {CategoryComponent} from './categories/category/category.component';
import {WebsitePagesComponent} from './website-pages/website-pages.component';
import {WebsitePageComponent} from './website-pages/website-page/website-page.component';
import {RemoveMyAccountComponent} from './remove-my-account/remove-my-account.component';
import {KoshkListComponent} from './koshk-list/koshk-list.component';
import {AffiliatePageComponent} from './affiliate-page/affiliate-page.component';
import {AffiliateInvoicesComponent} from './affiliate-invoices/affiliate-invoices.component';
import {AffiliateMerchantsComponent} from './affiliate-merchants/affiliate-merchants.component';
import {WithdrawHistoryComponent} from './affiliate-page/withdraw-history/withdraw-history.component';


export const privateRoutes: Routes = [
  {
    path: '',
    component: PrivateComponent,
    canActivate: [AuthGuardService],
    children: [
      {path: '', component: HomeComponent},
      {path: 'products', component: ProductsComponent},
      {path: 'product/:status/:productId', component: ProductComponent},
      {path: 'product/:status', component: ProductComponent},
      {path: 'collections', component: CategoriesComponent},
      {path: 'remove-my-account', component: RemoveMyAccountComponent},
      {path: 'collections/:status/:collectionId', component: CategoryComponent},
      {path: 'collections/:status', component: CategoryComponent},
      {path: 'webpages', component: WebsitePagesComponent},
      {path: 'webpages/:status/:websitePageId', component: WebsitePageComponent},
      {path: 'webpages/:status', component: WebsitePageComponent},
      {path: 'orders/:status', component: OrdersComponent},
      {path: 'assign-sub-accounts/:requestNo/:source', component: SubAccountsAssignmentFormComponent},
      {path: 'newOrder', component: OrderComponent},
      {path: 'productModal', component: ProductUpdateComponent},
      {path: 'clients', component: ClientsComponent},
      {path: 'sub-accounts', component: SubAccountsComponent},
      {path: 'new-sub-accounts-requests', component: NewSubAccountsRequestListComponent},
      {path: 'settings', component: SettingsListComponent},
      {path: 'koshk', component: KoshkListComponent},
      {path: 'affiliate', component: AffiliatePageComponent},
      {path: 'affiliate-invoices', component: AffiliateInvoicesComponent},
      {path: 'affiliate-merchants', component: AffiliateMerchantsComponent},
      {path: 'affiliate-withdraw-history', component: WithdrawHistoryComponent},
      {path: 'settings-update', component: SettingsUpdateComponent},
      {path: 'subscription-update', component: SubscriptionUpdateComponent},
      {path: 'api-keys', component: ApiKeysComponent},
      {path: 'request-update-account', component: RequestUpdateAccountComponent},
      {path: 'bank-update', component: BankUpdateComponent},
      {path: 'theme-settings', component: ThemeSettingsComponent},
      {path: 'choose-subscription', component: ChoosePackagesComponent},
      {path: 'renew-subscription', component: RenewSubscriptionComponent},
      {path: 'confirm-package', component: ConfirmChoosingPackageComponent},
      {path: 'process-payment', component: ProcessPaymentComponent},
      {path: 'process-sub-account-payment', component: ProcessSubAccountPaymentComponent},
      {path: 'balance', component: BalanceComponent},
      {path: 'partner', loadChildren: () => import('./partners/partner.module').then(m => m.PartnerModule)},
    ]
  }
];

// @NgModule({
//   imports: [RouterModule.forChild(routes)],
//   exports: [RouterModule]
// })
// export class PrivateRoutingModule {
// }
